export function DOTToTikz(str, dotDescription) {
  let tikz = "\\begin{tikzpicture}";
  tikz += "\n";
  tikz +=
    "[->,>=stealth',shorten >=2pt,auto,node distance=2cm, scale = 0.8, transform shape,accepting/.style=accepting by double,initial text=,every state/.style={thick,fill=red!20,draw=gray}]";
  tikz += "\n";
  const nTransitions = dotDescription.transitions.length;
  //let dotD = dotDescription;
  const tamStates = dotDescription.objectStates.length;
  for (var i = 0; i < tamStates; i++) {
    tikz += "  \\node[";
    if (dotDescription.objectStates[i].isInitial) {
      tikz += "initial,state] ";
    }
    if (dotDescription.objectStates[i].isFinal) {
      tikz += "accepting,state] ";
    } else if (!dotDescription.objectStates[i].isInitial) {
      tikz += "state]          ";
    }
    tikz += "(";
    tikz += dotDescription.objectStates[i].text.toUpperCase();
    tikz += ")  at ";
    tikz += "(";
    tikz += dotDescription.objectStates[i].x.toString()[0];
    tikz += ",";
    tikz += dotDescription.objectStates[i].y.toString()[0];
    tikz += ")";
    tikz += "  {$";
    //let stateNum = [];
    //let statesString = dotDescription.objectStates[i].text.split("q");
    var num = dotDescription.objectStates[i].text.split("q")[1];
    tikz += "q_";
    tikz += num;
    tikz += "$};";
    tikz += "\n";
  }
  if (!nTransitions == 0) {
    tikz += "\n"; // WRITE TRANSITIONS
    tikz += "  \\path ";
  } // adsf
  var transit = "";
  if (nTransitions == 1) {
    var originState = dotDescription.transitions[0].split("->")[0];
    var destinyState = dotDescription.transitions[0]
      .split("->")[1]
      .split("[")[0];
    var label = dotDescription.transitions[0].split(`"`)[1];
    if (label === "λ") {
      label = "$\\lambda$";
    }
    if (originState === destinyState) {
      transit += "        (" + originState.toUpperCase() + ") ";
      transit += "edge " + "[loop above] node ";
      transit += " {" + label + "} ";
      transit += "(" + destinyState.toUpperCase() + ")";
    } else {
      transit += "(" + originState.toUpperCase() + ") ";
      transit += "edge               node";
      transit += " {" + label + "} ";
      transit += "(" + destinyState.toUpperCase() + ")";
    }
    transit += ";\n";
  } else {
    for (var k = 0; k < nTransitions; k++) {
      originState = dotDescription.transitions[k].split("->")[0];
      destinyState = dotDescription.transitions[k].split("->")[1].split("[")[0];
      label = dotDescription.transitions[k].split(`"`)[1];
      if (!k + 1 > nTransitions) {
        var originStateNext = dotDescription.transitions[k + 1].split("->")[0];
        var destinyStateNext = dotDescription.transitions[k + 1]
          .split("->")[1]
          .split("[")[0];
      }
      if (label === "λ") {
        label = "$\\lambda$";
      }
      if (originState === destinyState) {
        transit += "        (" + originState.toUpperCase() + ") ";
        transit += "edge " + "[loop above] node ";
        transit += " {" + label + "} ";
        transit += "(" + destinyState.toUpperCase() + ")";
      } else {
        transit += "(" + originState.toUpperCase() + ") ";
        transit += "edge               node";
        transit += " {" + label + "} ";
        transit += "(" + destinyState.toUpperCase() + ")";
      }
      if (
        destinyState === originStateNext &&
        destinyState != destinyStateNext
      ) {
        transit += "\n    edge node " + " {" + label + "} ";
        transit += "(" + destinyStateNext.toUpperCase() + ")";
        k++;
      }
      if (k + 1 < nTransitions) {
        transit += "\n";
      } else {
        transit += ";\n";
      }
    }
  }
  transit += "\\end{tikzpicture}";
  tikz += transit;
  return tikz;
}
